import React from 'react';

import { Button } from 'lib/button';
import PropTypes from 'prop-types';

import { getCellRendererProps } from './getCellRendererProps';
import { LinkRenderer } from './LinkRenderer';
import { ROW_SIZES } from '../constants';

const ButtonRenderer = ({ rowSize = ROW_SIZES.STANDARD, value, ...other }) => {
  const buttonProps = getCellRendererProps(other);
  const { href, label } = value;
  const isMobile = rowSize === ROW_SIZES.MOBILE;

  if (isMobile) {
    return <Button href={href} text={label} {...buttonProps} />;
  }

  return <LinkRenderer value={value} {...other} />;
};

ButtonRenderer.propTypes = {
  /** Table row height */
  rowSize: PropTypes.number,
  /** Link href and label to render in a table cell as button */
  value: PropTypes.shape({
    href: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
  }).isRequired,
};

export { ButtonRenderer };
